import { CubkCardState } from './lib/cubkProgress.types'

export const CUBK_CARD_EXPANDED_KEY = 'cubk_card_expanded'
export const CUBK_FOLLOWUP_ALERT_DISMISSED_KEY = 'cubk_followup_alert_dismissed'
// Latch flipped true on the first COMPLETE render so we auto-expand
// only once; subsequent renders defer to CUBK_CARD_EXPANDED_KEY.
export const CUBK_COMPLETE_AUTO_EXPANDED_KEY = 'cubk_complete_auto_expanded'

const S3_BASE = 'https://heard-images.s3.amazonaws.com/assets'

export const CUBK_ILLUSTRATIONS: Record<CubkCardState, string> = {
  [CubkCardState.SYNC_AND_CATEGORIZATION]: `${S3_BASE}/Bookkeeping Progress.svg`,
  [CubkCardState.PREPARE_FOR_BOOKKEEPING]: `${S3_BASE}/ledger-instant-value-loop.svg`,
  [CubkCardState.BK_TEAM_REVIEW]: `${S3_BASE}/review-transactions.svg`,
  [CubkCardState.BK_TEAM_REVIEW_AFTER_FOLLOWUP]: `${S3_BASE}/review-transactions.svg`,
  [CubkCardState.YOUR_REVIEW]: `${S3_BASE}/review-transactions.svg`,
  [CubkCardState.COMPLETE]: `${S3_BASE}/Books complete.svg`,
  [CubkCardState.BANK_INCOMPATIBLE]: `${S3_BASE}/Bank incompatible.svg`,
  [CubkCardState.BANKING_AWAITING_APPLICATION]: `${S3_BASE}/Bank incompatible.svg`,
  [CubkCardState.BANKING_APPROVED_NO_ACCOUNTS]: `${S3_BASE}/Bank incompatible.svg`,
  [CubkCardState.BANKING_NO_ACCOUNTS_FALLBACK]: `${S3_BASE}/Bank incompatible.svg`,
}

export const CUBK_ILLUSTRATION_ALTS: Record<CubkCardState, string> = {
  [CubkCardState.SYNC_AND_CATEGORIZATION]: 'Bookkeeping Progress',
  [CubkCardState.PREPARE_FOR_BOOKKEEPING]: 'Prepare for bookkeeping',
  [CubkCardState.BK_TEAM_REVIEW]: 'Review Transactions',
  [CubkCardState.BK_TEAM_REVIEW_AFTER_FOLLOWUP]: 'Review Transactions',
  [CubkCardState.YOUR_REVIEW]: 'Your Review',
  [CubkCardState.COMPLETE]: 'Books complete',
  [CubkCardState.BANK_INCOMPATIBLE]: 'Bank Incompatible',
  [CubkCardState.BANKING_AWAITING_APPLICATION]: 'Account connection needed',
  [CubkCardState.BANKING_APPROVED_NO_ACCOUNTS]: 'Account connection needed',
  [CubkCardState.BANKING_NO_ACCOUNTS_FALLBACK]: 'Account connection needed',
}

export const CUBK_TITLES: Record<CubkCardState, string> = {
  [CubkCardState.SYNC_AND_CATEGORIZATION]: "We're catching up your books",
  [CubkCardState.PREPARE_FOR_BOOKKEEPING]: "We're catching up your books",
  [CubkCardState.BK_TEAM_REVIEW]: "We're catching up your books",
  [CubkCardState.BK_TEAM_REVIEW_AFTER_FOLLOWUP]: "We're catching up your books",
  [CubkCardState.YOUR_REVIEW]: "We're catching up your books",
  [CubkCardState.COMPLETE]: 'Catch Up Bookkeeping Complete',
  [CubkCardState.BANK_INCOMPATIBLE]:
    'Account connection needed to start bookkeeping',
  [CubkCardState.BANKING_AWAITING_APPLICATION]:
    'Account connection needed to start bookkeeping',
  [CubkCardState.BANKING_APPROVED_NO_ACCOUNTS]:
    'Account connection needed to start bookkeeping',
  [CubkCardState.BANKING_NO_ACCOUNTS_FALLBACK]:
    'Account connection needed to start bookkeeping',
}

export const CUBK_SUBTITLES: Record<CubkCardState, string | null> = {
  [CubkCardState.SYNC_AND_CATEGORIZATION]:
    'Syncing transactions and categorizing deductions',
  [CubkCardState.PREPARE_FOR_BOOKKEEPING]:
    'Complete your setup items so your bookkeeper can get started',
  [CubkCardState.BK_TEAM_REVIEW]:
    "We're reviewing books for accuracy and tax readiness",
  [CubkCardState.BK_TEAM_REVIEW_AFTER_FOLLOWUP]:
    "We're reviewing books for accuracy and tax readiness",
  [CubkCardState.YOUR_REVIEW]:
    'We found some issues and need your clarification',
  [CubkCardState.COMPLETE]: null,
  [CubkCardState.BANK_INCOMPATIBLE]:
    'Support will reach out to you to help you resolve this issue',
  [CubkCardState.BANKING_AWAITING_APPLICATION]:
    'Your Heard Banking application is under review',
  [CubkCardState.BANKING_APPROVED_NO_ACCOUNTS]: 'Complete Heard Banking setup',
  [CubkCardState.BANKING_NO_ACCOUNTS_FALLBACK]: 'Complete Heard Banking setup',
}

export const CUBK_CARD_GRADIENT =
  'linear-gradient(180deg, rgba(141, 198, 210, 0.35) 0%, rgba(232, 239, 230, 0) 100%)'
